/**
 * @fileoverview Entity Picker cart presentation component
 */
// @ts-nocheck
goog.declareModuleId('yext.ui.components.entitypicker.Cart');


import {CartItemDropdown} from '/ui/components/entitypicker/cart/cartitemdropdown';
import {ItemTypes} from '/ui/components/entitypicker/container/itemtypes';
import {getEntityIcon} from '/ui/components/entitypicker/itemlist/entityicon';
import {EntityItem} from '/ui/components/entitypicker/itemlist/entityitem';
import {EntityTypeHeader} from '/ui/components/entitypicker/itemlist/entitytypeheader';
import {FolderItem} from '/ui/components/entitypicker/itemlist/folderitem';
import {LabelItem} from '/ui/components/entitypicker/itemlist/labelitem';
import {yext} from '/ui/lib/msg';

export class Cart extends React.Component {
  constructor(props) {
    super(props);

    this.getEmptyMessage = this.getEmptyMessage.bind(this);
  }

  getEmptyMessage() {
    const {
      asFilter,
      locationsOnly,
      allowedItems = [], // safety fallback. Should always be instantiated to a default by the parent component
    } = this.props;
    if (asFilter) {
      if (allowedItems.length === 1) {
        switch (allowedItems[0]) {
          case ItemTypes.ENTITIES:
            return locationsOnly ? yext.msg('All Locations Selected') : yext.msg('All Entities Selected');
          case ItemTypes.FOLDERS:
            return yext.msg('All Folders Selected');
          case ItemTypes.LABELS:
            return yext.msg('All Labels Selected');
          case ItemTypes.ENTITYTYPES:
            return yext.msg('All Entity Types Selected');
          default:
            console.warn('EntityPicker Cart: allowedItems prop incorrectly specified');
        }
      }
      return yext.msg('All Items Selected'); // allowedItems.length !== 1 or allowedItems[0] doesn't match a valid itemType
    } else {
      return yext.msg('Selected Items (0)');
    }
  }

  render() {
    const {
      removeEntityTypeHandler,
      removeEntityHandler,
      removeFolderHandler,
      removeLabelHandler,
      locationsOnly,
      removeAllOfTypeHandler,
      items: cart,
      asFilter,
      allowedItems,
    } = this.props;

    const multipleTypes = cart.hasMultipleTypes();
    const allSelected = cart.allSelected;
    const usingEntities = allowedItems.includes(ItemTypes.ENTITIES);
    const resetMessage = asFilter
      ? yext.msg('Reset to All')
      : yext.msg('Reset to None');
    const resetButton = (!cart.isEmpty())
        && <button
          type="button"
          onClick={this.props.resetHandler}
          className="uep-cart-reset">
          {resetMessage}
        </button>;

    const cartProps = {
      cart,
      resetButton,
      removeEntityTypeHandler,
      removeEntityHandler,
      removeFolderHandler,
      removeLabelHandler,
      allSelected,
      locationsOnly,
      usingEntities,
    };
    return (
      multipleTypes
      ? <MultiTypeCart {...cartProps} removeAllOfTypeHandler={removeAllOfTypeHandler} />
      : <SingleTypeCart {...cartProps} emptyMessage={this.getEmptyMessage()}/>
    );
  }
}

function SingleTypeCart({
  cart,
  resetButton,
  removeEntityTypeHandler,
  removeEntityHandler,
  removeFolderHandler,
  removeLabelHandler,
  allSelected,
  locationsOnly,
  emptyMessage,
  usingEntities,
}) {
  const cartItems = renderCartItems(
    cart,
    removeEntityTypeHandler,
    removeEntityHandler,
    removeFolderHandler,
    removeLabelHandler,
    usingEntities);

  const itemType = cart.typesInCart()[0];
  return (
    <CartItemDropdown
      numItems={cart.total}
      additionalHeaderChildren={resetButton}
      allSelected={allSelected}
      type={itemType}
      locationsOnly={locationsOnly}
      emptyMessage={emptyMessage}
    >
      {cartItems}
    </CartItemDropdown>
  );
}

function MultiTypeCart({
  cart,
  resetButton,
  removeEntityTypeHandler,
  removeEntityHandler,
  removeFolderHandler,
  removeLabelHandler,
  allSelected,
  locationsOnly,
  removeAllOfTypeHandler,
  usingEntities,
}) {
  const headerMessage = allSelected.length > 0
  ? yext.msg('Selected Items')
  : yext.msg('Selected Items ({0})', cart.total);
  const showEntityTypes = !!cart.entityTypes.length || allSelected.includes(ItemTypes.ENTITYTYPES);
  const showEntities = !!cart.entities.length || allSelected.includes(ItemTypes.ENTITIES);
  const showFolders = !!cart.folders.length || allSelected.includes(ItemTypes.FOLDERS);
  const showLabels = !!cart.labels.length || allSelected.includes(ItemTypes.LABELS);

  return (
    <React.Fragment>
      <div className="uep-cart-header">
        <div className="uep-cart-title">{headerMessage}</div>
        {resetButton}
      </div>
      {showEntityTypes
        && <CartItemDropdown
          numItems={cart.entityTypes.length}
          type="ENTITYTYPES"
          allSelected={allSelected}
          multiType={true}
          usingEntities={usingEntities}
        >
          {renderCartEntityTypes(cart.entityTypes, removeEntityTypeHandler, usingEntities)}
        </CartItemDropdown>
      }
      {showEntities
        && <CartItemDropdown
          numItems={cart.entities.length}
          type="ENTITIES"
          allSelected={allSelected}
          locationsOnly={locationsOnly}
          multiType={true}
        >
          {renderCartEntities(cart.entities, removeEntityHandler)}
        </CartItemDropdown>
      }
      {showFolders
        && <CartItemDropdown
          numItems={cart.folders.length}
          type="FOLDERS"
          allSelected={allSelected}
          removeAllHandler={removeAllOfTypeHandler}
          multiType={true}
        >
          {renderCartFolders(cart.folders, removeFolderHandler)}
        </CartItemDropdown>
      }
      {showLabels
        && <CartItemDropdown
          numItems={cart.labels.length}
          type="LABELS"
          allSelected={allSelected}
          removeAllHandler={removeAllOfTypeHandler}
          multiType={true}
        >
          {renderCartLabels(cart.labels, removeLabelHandler)}
        </CartItemDropdown>
      }
    </React.Fragment>
  );
}

// TODO(jdelerme): memoize cart render with custom serializer
function renderCartItems(
  cart,
  removeEntityTypeHandler,
  removeEntityHandler,
  removeFolderHandler,
  removeLabelHandler,
  usingEntities,
) {
  const entityTypeItems =
    renderCartEntityTypes(cart.entityTypes, removeEntityTypeHandler, usingEntities);
  const entityItems = renderCartEntities(cart.entities, removeEntityHandler);
  const folderItems = renderCartFolders(cart.folders, removeFolderHandler);
  const labelItems = renderCartLabels(cart.labels, removeLabelHandler);
  return [...entityTypeItems, ...entityItems, ...folderItems, ...labelItems];
}

function renderCartEntityTypes(entityTypes, removeHandler, usingEntities) {
  return entityTypes.map(t =>
    <li className="uep-type-item"
      key={`entity-type-${t.id}`}
    >
      <EntityTypeHeader
        type={t}
        icon={getEntityIcon(t)}
        additionalCssClass="uep-entity-section-collapsed"
        onClick={() => removeHandler(t)}
        usingEntities={usingEntities}
      />
    </li>);
}

function renderCartEntities(entities, removeHandler) {
  return entities.map(e =>
    <EntityItem
      key={`entity-${e.id}`}
      entity={e}
      icon={getEntityIcon(e.type)}
      onClick={() => removeHandler(e)}
    />);
}

function renderCartFolders(folders, removeHandler) {
  return folders.map(f =>
    <FolderItem
      key={`folder-${f.id}`}
      folder={f}
      onClick={() => removeHandler(f)}
    />);
}

function renderCartLabels(labels, removeHandler) {
  return labels.map(l =>
    <LabelItem
      key={`label-${l.id}`}
      label={l}
      onClick={() => removeHandler(l)}
    />);
}
